import CircleIcon from "@mui/icons-material/Circle";
import { Tooltip } from "@mui/material";

type ControlDataStatusIndicatorProps = {
    isLoading: boolean;
    loadingLabel?: string;
    readyLabel?: string;
};

export default function ControlDataStatusIndicator(
    props: ControlDataStatusIndicatorProps
) {
    const {
        isLoading,
        loadingLabel = "Dados sendo carregados",
        readyLabel = "Dados carregados",
    } = props;

    const title = isLoading ? loadingLabel : readyLabel;
    const color = isLoading ? "#f57c00" : "green";

    return (
        <Tooltip title={title} arrow>
            <CircleIcon
                sx={{
                    color,
                    width: 16,
                    height: 16,
                    marginLeft: "8px",
                }}
            />
        </Tooltip>
    );
}